import {observer} from "mobx-react";
import {Button} from "../../../../basic-ui-components/button/base/button.component";
import {useServices} from "../../../../react-hooks/use-services.hook";
import {Magic8BallAnimationComponent} from "../../../magic-8-ball-animation/magic-8-ball-animation.component";

export const Magic8BallShowcase: React.FC = observer(() => {
    const services = useServices();

    return <>
        <Button preset="primary" onClick={() => {
            services.magic8ball.showMagicBall();
        }}>Magic 8 ball</Button>
        <Magic8BallAnimationComponent
            showIntent={services.magic8ball.showIntent}
        />
        <p style={{fontSize: "1.6rem"}}>
            Number of shakes: {services.inGameTicket.availableTickets.length}
        </p>
        {/* <div>
            {isShown ? "Magic 8 Ball Shown" : showIntent ? "Magic 8 Ball LOADING" : "Click the button"}
        </div> */}
    </>;
});